// extracted by mini-css-extract-plugin
export var fadeInAnimation = "TabPanel-module--fadeInAnimation--957b1";
export var hiddenDesktop = "TabPanel-module--hiddenDesktop--e88ba";